import React from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { CATEGORIES } from '../constants/categories';

function AllCategories() {
    const navigate = useNavigate();

    return (
        <main>
            <section className="pt-5 pb-5">
                <div className="container">
                    <div className="mb-4">
                        <p style={{ fontSize: 12, fontWeight: 600, color: '#2563eb', textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: 4 }}>
                            Browse
                        </p>
                        <h4 style={{ fontWeight: 700, color: '#0f172a', margin: 0 }}>All Categories</h4>
                    </div>
                    <Grid>
                        {CATEGORIES.map((cat, i) => (
                            <Card
                                key={i}
                                $gradient={cat.gradient}
                                $iconBg={cat.iconBg}
                                onClick={() => navigate(`/category/${encodeURIComponent(cat.name)}`)}
                                aria-label={cat.name}
                            >
                                <span className="cat-tag">{cat.tag}</span>
                                <div className="cat-img-wrap">
                                    <img src={cat.img} alt={cat.name} loading="lazy" />
                                </div>
                                <div className="cat-text">
                                    <h6 className="cat-name">{cat.name}</h6>
                                    <p className="cat-sub">{cat.sub}</p>
                                </div>
                                <div className="cat-footer">
                                    <span className="cat-cta">
                                        Shop Now <i className="fa fa-arrow-right" />
                                    </span>
                                </div>
                            </Card>
                        ))}
                    </Grid>
                </div>
            </section>
        </main>
    );
}

export default AllCategories;

const Grid = styled.div`
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 20px;

    @media (max-width: 992px) { grid-template-columns: repeat(3, 1fr); }
    @media (max-width: 768px) { grid-template-columns: repeat(2, 1fr); gap: 14px; }
    @media (max-width: 480px) { grid-template-columns: repeat(2, 1fr); gap: 10px; }
`;

const Card = styled.div`
    background: ${({ $gradient }) => $gradient};
    border-radius: 18px;
    border: 1px solid rgba(255,255,255,0.8);
    padding: 24px 20px 20px;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
    position: relative;
    text-align: center;
    box-shadow: 0 1px 4px rgba(0,0,0,0.06);
    transition: transform 0.28s cubic-bezier(0.34,1.56,0.64,1), box-shadow 0.28s ease;

    &::before {
        content: '';
        position: absolute;
        top: 0; left: 10%; right: 10%;
        height: 1px;
        background: rgba(255,255,255,0.9);
        border-radius: 1px;
    }

    &:hover {
        transform: translateY(-6px);
        box-shadow: 0 16px 36px rgba(0,0,0,0.10);
    }

    .cat-tag {
        position: absolute;
        top: 12px; right: 12px;
        font-size: 9px;
        font-weight: 700;
        letter-spacing: 0.06em;
        text-transform: uppercase;
        color: #475569;
        background: rgba(255,255,255,0.72);
        padding: 3px 8px;
        border-radius: 20px;
        backdrop-filter: blur(4px);
        line-height: 1.6;
    }

    .cat-img-wrap {
        width: 100px;
        height: 100px;
        border-radius: 50%;
        background: ${({ $iconBg }) => $iconBg};
        display: flex;
        align-items: center;
        justify-content: center;
        overflow: hidden;
        flex-shrink: 0;
        box-shadow: 0 4px 14px rgba(0,0,0,0.10);
        transition: transform 0.3s ease;
    }

    &:hover .cat-img-wrap { transform: scale(1.08); }

    .cat-img-wrap img {
        width: 72%;
        height: 72%;
        object-fit: contain;
    }

    .cat-text {
        display: flex;
        flex-direction: column;
        gap: 4px;
        width: 100%;
    }

    .cat-name {
        font-size: 14px;
        font-weight: 700;
        color: #0f172a;
        margin: 0;
        font-family: 'Poppins', sans-serif;
    }

    .cat-sub {
        font-size: 12px;
        color: #64748b;
        margin: 0;
        font-weight: 400;
    }

    .cat-footer {
        width: 100%;
        padding-top: 10px;
        border-top: 1px solid rgba(0,0,0,0.06);
        margin-top: auto;
    }

    .cat-cta {
        font-size: 12px;
        font-weight: 600;
        color: #2563eb;
        font-family: 'Poppins', sans-serif;
        display: inline-flex;
        align-items: center;
        gap: 5px;

        i { font-size: 10px; transition: transform 0.2s ease; }
    }

    &:hover .cat-cta i { transform: translateX(3px); }

    @media (max-width: 768px) {
        padding: 20px 14px 16px;
        .cat-img-wrap { width: 80px; height: 80px; }
        .cat-name { font-size: 13px; }
    }
`;
